import {useDispatch, useSelector} from "react-redux";
import {
    Checkbox,
    Dialog, DialogActions,
    DialogContent,
    makeStyles,
    Table, TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow, TextField
} from "@material-ui/core";
import {setOpenedImport} from "../../../reducers/applicationBuilder.slice";
import {fetchTreeThunk} from "../../../reducers/fetchTree.thunk";
import React, {useEffect, useState} from "react";
import DialogTitle from "@material-ui/core/DialogTitle";
import request from "../../../../../Services/API/Requests";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import TablePagination from "@material-ui/core/TablePagination";
import _ from "lodash";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import Search from "@material-ui/icons/Search";

const useStyles = makeStyles(() => ({
    container: {
        display: "flex",
    }
}))
const ImportData = () => {
    const [selected, setSelected] = useState([]);
    const [filterString, setFilterString] = useState("");
    const classes = useStyles();
    const isOpenedImport = useSelector(state => state.applicationBuilder.isOpenedImport);
    const applicationId = useSelector((state) => state.applicationBuilder.applicationId)
    const dispatch = useDispatch();

    async function importToEntity() {
        try {
            await request({
                url: "/application/import",
                data: {
                    type: "import",
                    _entity: isOpenedImport === 'entity' ? 'schema' : isOpenedImport,
                    records: selected,
                    application: applicationId
                }
            })
            await dispatch(fetchTreeThunk(applicationId))
            dispatch(setOpenedImport(null))
        } catch (e) {
            console.log('import error', e);
        }
    }

    return (
        <Dialog
            open={Boolean(isOpenedImport)}
            onClose={() => {
                dispatch(setOpenedImport(null))
            }}
            fullWidth
            maxWidth={"md"}
        >
            <DialogTitle>
                <div style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: 'center'
                }}>
                    <div>
                        Import {isOpenedImport}
                    </div>
                    <TextField
                        fullWidth={false}
                        variant="outlined"
                        placeholder={"search..."}
                        value={filterString}
                        onChange={e => setFilterString(e.target.value)}
                        size={"small"}
                        autoFocus={true}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment
                                    classes={{positionStart: classes.adornment}}
                                    position="start">
                                    <IconButton
                                        size={"small"}
                                        aria-label="search"
                                    >
                                        <Search/>
                                    </IconButton>
                                </InputAdornment>),
                        }}
                        style={{
                            marginBottom: 10,
                        }}
                    />
                </div>
            </DialogTitle>
            <DialogContent dividers={true}>
                <div
                    className={classes.container}
                >
                    <div style={{
                        width: "100%"
                    }}>
                        <ImportList
                            id={isOpenedImport}
                            selected={selected}
                            setSelected={setSelected}
                            filterString={filterString}
                        />
                    </div>
                    <div style={{
                        width: "0%"
                    }}>

                    </div>
                </div>
            </DialogContent>
            <DialogActions style={{
                width: '100%',
                justifyContent: 'start',
                padding: '10px 25px'
            }}>
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    width: '100%'
                }}>
                    <div>
                        {Boolean(selected.length > 0) && (
                            <>
                                {selected.length} {selected.length === 1 ? "record" : "records"} selected
                            </>
                        )}
                    </div>
                    <Button
                        disabled={!selected.length}
                        onClick={importToEntity}
                        variant="contained"
                        color="primary"
                    >
                        Import
                    </Button>
                </div>
            </DialogActions>
        </Dialog>
    )
}

export default ImportData;

const ImportList = ({id, selected, setSelected, filterString}) => {
    const applicationId = useSelector((state) => state.applicationBuilder.applicationId)
    const [page, setPage] = useState(0);

    const [data, setData] = useState({totalElements: 0, content: []});

    function handleChangePage(event, page) {
        setPage(page)
    }

    const handleSelectAllClick = (event) => {
        const newSelected = collect(event.target.checked, data.content.map((n) => n.id), {data: selected})
        setSelected(newSelected);
    };
    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        setSelected(newSelected);
    };
    useEffect(() => {
        if (id) {
            const entity = id === 'entity' ? 'schema' : id;
            request({
                url: `/list/getData`,
                data: {
                    id: `${entity}DefaultList`,
                    pageNumber: page,
                    pageSize: 15,
                    textFilter: filterString,
                    advancedFilter: [{
                        "field": "application",
                        "operand": "notEqual",
                        "value": applicationId
                    }]
                }
            }).then(data => {
                setData(data)
            }).catch(err => {
                console.log('get import list error', err);
            })
        }
    }, [id, page, filterString]);
    const isSelected = (name) => selected.indexOf(name) !== -1;
    const cntSelected = countSelected(data.content.map(i => i.id), selected)
    return (
        <div>
            <Paper>
                <TableContainer
                    style={{
                        width: '100%',
                        height: 300,
                    }}
                >

                    <Table
                        size={"small"}
                        stickyHeader

                    >
                        <TableHead>
                            <TableRow>
                                <TableCell>
                                    <Checkbox
                                        size={"small"}
                                        indeterminate={cntSelected > 0 && cntSelected < data.content.length}
                                        checked={cntSelected > 0 && cntSelected === data.content.length}
                                        onChange={handleSelectAllClick}
                                        style={{
                                            padding: 0
                                        }}
                                    /></TableCell>
                                <TableCell>Id</TableCell>
                                <TableCell>Name</TableCell>
                                {/*<TableCell>Application</TableCell>*/}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.content.map((item, index) => {
                                    const isItemSelected = isSelected(item.id)
                                    return (
                                        <TableRow key={index} hover selected={isItemSelected}
                                                  onClick={(event) => handleClick(event, item.id)}
                                        >
                                            <TableCell>
                                                <Checkbox
                                                    onClick={(e) => {
                                                        handleClick(e, item.id)
                                                    }}
                                                    checked={isItemSelected}
                                                    size={"small"}
                                                    style={{
                                                        padding: 0
                                                    }}
                                                />
                                            </TableCell>
                                            <TableCell>
                                                {item.id}
                                            </TableCell>
                                            <TableCell>
                                                {item.name}
                                            </TableCell>
                                            {/*<TableCell>*/}
                                            {/*    {item.application}*/}
                                            {/*</TableCell>*/}

                                        </TableRow>
                                    )
                                }
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[]}
                    component="div"
                    count={data.totalElements}
                    rowsPerPage={15}
                    page={page}
                    onChangePage={handleChangePage}
                    //onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
        </div>

    )
}

function collect(isChecked, content, selectedData) {
    let newSelected = selectedData ? [...selectedData.data || []] : [];
    if (isChecked) {
        newSelected = content;

        let selected = _.concat(selectedData.data, newSelected);
        return _.map(
            _.uniq(
                _.map(selected, function (obj) {
                    return JSON.stringify(obj);
                })
            ), function (obj) {
                return JSON.parse(obj);
            }
        );
    }
    if (!isChecked) {
        return _.filter(newSelected, (row) => {
            return content.findIndex(item => item === row) === -1 //_.findIndex(content, row) === -1
        });
    }
}

function countSelected(content, selectedData) {
    const count = _.filter(content, (item) => {
        return selectedData.findIndex(sel => sel === item) !== -1;
    });

    return count.length;
}